import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import SuperAdminRoute from "@/components/SuperAdminRoute";
import Landing from "@/pages/Landing";
import GuestInvite from "@/pages/GuestInvite";
import AdminLogin from "@/pages/AdminLogin";
import AdminLayout from "@/pages/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Guests from "@/pages/admin/Guests";
import Schedule from "@/pages/admin/Schedule";
import Gallery from "@/pages/admin/Gallery";
import CheckIn from "@/pages/admin/CheckIn";
import EventSettings from "@/pages/admin/EventSettings";
import Rooms from "@/pages/admin/Rooms";
import Travel from "@/pages/admin/Travel";
import Messages from "@/pages/admin/Messages";
import Explore from "@/pages/admin/Explore";
import Events from "@/pages/admin/Events";
import Admins from "@/pages/admin/Admins";
import Account from "@/pages/admin/Account";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/invite/:token" element={<GuestInvite />} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<Dashboard />} />
              <Route path="guests" element={<Guests />} />
              <Route path="rooms" element={<Rooms />} />
              <Route path="travel" element={<Travel />} />
              <Route path="messages" element={<Messages />} />
              <Route path="explore" element={<Explore />} />
              <Route path="checkin" element={<CheckIn />} />
              <Route path="schedule" element={<Schedule />} />
              <Route path="gallery" element={<Gallery />} />
              <Route path="settings" element={<EventSettings />} />
              <Route
                path="events"
                element={
                  <SuperAdminRoute>
                    <Events />
                  </SuperAdminRoute>
                }
              />
              <Route
                path="admins"
                element={
                  <SuperAdminRoute>
                    <Admins />
                  </SuperAdminRoute>
                }
              />
              <Route path="account" element={<Account />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
